// redux/reducers/twoFactor.js
const SET_2FA_REQUIRED = 'twoFactor/SET_REQUIRED';
const VERIFY_2FA_SUCCESS = 'twoFactor/VERIFY_SUCCESS';
const VERIFY_2FA_FAIL = 'twoFactor/VERIFY_FAIL';
const RESET_2FA = 'twoFactor/RESET';

export const set2FARequired = (challengeToken, email) => ({
  type: SET_2FA_REQUIRED,
  payload: { challengeToken, email }
});

export const verify2FASuccess = () => ({ type: VERIFY_2FA_SUCCESS });
export const verify2FAFail = (error) => ({ type: VERIFY_2FA_FAIL, error });
export const reset2FA = () => ({ type: RESET_2FA });

const initialState = {
  required: false,
  challengeToken: null,
  email: null,
  error: null
};

export default function twoFactorReducer(state = initialState, action) {
  switch (action.type) {
    case SET_2FA_REQUIRED:
      return { ...state, required: true, ...action.payload, error: null };
    case VERIFY_2FA_SUCCESS:
      return { ...state, required: false, challengeToken: null, email: null, error: null };
    case VERIFY_2FA_FAIL:
      return { ...state, error: action.error };
    case RESET_2FA:
      return initialState;
    default:
      return state;
  }
}
